import { Route } from "@angular/router";
import { AppConfiguredGuard } from "./guards/app-configured.guard";
import { AuthGuard } from "./guards/auth.guard";
import { StillActiveGuard } from "./guards/still-active.guard";
import { AssignmentContainerComponent } from "./pages/assignment-container/assignment-container.component";
import { AssignmentDetailsComponent } from "./pages/assignment-container/assignment-details/assignment-details.component";
import { AssignmentParkingBansComponent } from "./pages/assignment-container/assignment-parking-bans/assignment-parking-bans.component";
import { CreateParkingBanComponent } from "./pages/assignment-container/assignment-parking-bans/create-parking-ban/create-parking-ban.component";
import { EditParkingBanComponent } from "./pages/assignment-container/assignment-parking-bans/edit-parking-ban/edit-parking-ban.component";
import { SignScanDetailComponent } from "./pages/assignment-container/assignment-parking-bans/edit-parking-ban/sign-scan-detail/sign-scan-detail.component";
import { AssignmentTasksComponent } from "./pages/assignment-container/assignment-tasks/assignment-tasks.component";
import { TaskDetailsComponent } from "./pages/assignment-container/assignment-tasks/task-details/task-details.component";
import { AssignmentsComponent } from "./pages/assignments/assignments.component";
import { RootComponent } from "./pages/root.component";
import { SetupComponent } from "./pages/setup/setup.component";
import { TeamOverviewComponent } from "./pages/team-overview/team-overview.component";

export const appRoutes: Route[] = [
    {
        path: "",
        component: RootComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "setup",
        component: SetupComponent,
        canActivate: [AuthGuard],
    },
    {
        path: "team-overview",
        component: TeamOverviewComponent,
        canActivate: [AppConfiguredGuard],
    },
    {
        path: "assignments",
        component: AssignmentsComponent,
        canActivate: [AppConfiguredGuard],
    },
    {
        path: "assignment/:plannedAssignmentId",
        component: AssignmentContainerComponent,
        canActivate: [AppConfiguredGuard, StillActiveGuard],
        children: [
            {
                path: "details",
                component: AssignmentDetailsComponent,
            },
            {
                path: "tasks",
                component: AssignmentTasksComponent,
            },
            {
                path: "parking-bans",
                component: AssignmentParkingBansComponent,
            },
        ],
    },
    {
        path: "assignment/:plannedAssignmentId/parking-ban/create",
        component: CreateParkingBanComponent,
        canActivate: [AppConfiguredGuard, StillActiveGuard],
    },
    {
        path: "assignment/:plannedAssignmentId/parking-ban/:parkingBanId",
        component: EditParkingBanComponent,
        canActivate: [AppConfiguredGuard, StillActiveGuard],
    },
    {
        path: "assignment/:plannedAssignmentId/parking-ban/:parkingBanId/sign-scan/:signScanId",
        component: SignScanDetailComponent,
        canActivate: [AppConfiguredGuard, StillActiveGuard],
    },
    {
        path: "assignment/:plannedAssignmentId/task/:taskId",
        component: TaskDetailsComponent,
        canActivate: [AppConfiguredGuard, StillActiveGuard],
    },
    {
        path: "**",
        redirectTo: "",
    },
];
